<template>
    <div class="home">
        <div class="top"></div>
        <img src="@/assets/img/logo@2x.png" alt="">
        <div class="page">
            <div class="inp">
                <div class="til">{{ $t("login.inp")[0] }}</div>
                <input type="t" :placeholder="$t('login.inp')[1]" v-model="uid">
            </div>
            <div class="inp">
                <div class="til">&nbsp;</div>
                <input type="password" :placeholder="$t('login.inp')[2]" v-model="pas">
            </div>
            <Btn class="login-bn" @ck="login">登入</Btn>
        </div>
        <div class="foot">
            <div>
                {{ $t("foot")[0] }}<br>{{ $t("foot")[1] }}
            </div>
        </div>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'Home',
    mixins: [mainDelegate],
    data() {
        return {
            uid: process.env.TEST_USER,
            pas: process.env.TEST_PASS
        }
    },
    methods: {
        login() {
            this.loginApi({
                Username: this.uid,
                Password: this.pas
            })
            this.soundLibInit(['o', 'x', 'qa', 'end'])
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
img {
    width: 100%;
    padding: 16px 0 24px 0px;
}
.home {
    height: 100vh;
    background: url('../assets/img/bg.png');
}
.top {
    height: 10px;
    background: @main-color;
}
.page {
    padding: 32px 10px 32px 10px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 0px @main-color;
}
.inp {
    padding: 15px 0px;
    .til {
        font-weight: bold;
        text-align: left;
        font-size: 16px;
    }
    input {
        border: none;
        border-bottom: 2px solid rgb(151, 151, 151);
        background: none;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        &::placeholder {
            color: rgb(151, 151, 151);
        }
    }
}
.login-bn {
    margin-top: 15px;
}
.foot {
    display: none;
}

@media only screen and (min-width: @rwd) {
    img {
        width: 500px;
    }
    .page {
        width: 500px;
        margin: auto;
    }
    .inp {
        width: 315px;
        margin: auto;
    }
    .login-bn {
        width: 315px;
        margin: auto;
    }
    .foot {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0px;
        left: 0px;
        height: 94px;
        width: 100%;
        background: #444444;
        color: #999;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue